import { put, select } from 'redux-saga/effects';
import { requestedExcess, coverType } from '../state_selectors';

/**
 * Generator/Saga to set requestedExcess to results config helpers so results filters will get initial state and set filters requestedExcess and coverType
 * @param {Object} action - 'SET_FILTERS_EXCESS_COVERTYPE' action
 */
const setFiltersExcesCoverType = function* (action) {
    if (action.key) {
        const requestedExcessValue = yield select(requestedExcess);
        yield put({
            type: 'SET_RESULTS_CONFIG_VALUE',
            key: action.key,
            value: requestedExcessValue
        });
        yield put({
            type: 'SET_RESULTS_CONFIG_VALUE',
            key: 'filters.requestedExcess',
            value: requestedExcessValue
        });
        const coverTypeValue = yield select(coverType);
        yield put({
            type: 'SET_RESULTS_CONFIG_VALUE',
            key: 'filters.coverType',
            value: coverTypeValue
        });
    }
};

export default ['SET_FILTERS_EXCESS_COVERTYPE', setFiltersExcesCoverType];
